import { useContext } from 'react'
import { Helmet } from 'react-helmet-async'

import { useNumericParams } from '@domain-group/react-hooks'

import {
  Box, Button, Columns, LoadingModule, PageHeader,
} from '@domain-group/suit-theme'

import quoteAndFinanceTabBarItems from '@sections/Client/packs/Campaign/utils/generateQuoteAndFinanceTabBarItems'

import useCampaign from '@hooks/useCampaign'
import useOrderReconciliation from '@hooks/useOrderReconciliation'

import NotificationBannerLocation from '@components/NotificationBannerLocation'
import NotificationModuleLocation from '@components/NotificationModuleLocation'
import OrderReconciliationList from '@components/OrderReconciliationList'
import ReconciliationTotals from '@components/ReconciliationTotals'

import PageContext from '@contexts/pageContext'

const PageContent = () => {
  const { campaignId } = useNumericParams()

  const { campaign, campaign: { address }, loading: loadingCampaign } = useCampaign({ id: campaignId })

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      showAddAccountingItemModal,
    },
  } = pageContext

  const orderReconciliationPayload = useOrderReconciliation(
    { campaign_id: campaignId, orderStatusGroupKey: 'complete' },
  )
  const { loadingOrderReconciliationItems } = orderReconciliationPayload

  const loading = loadingOrderReconciliationItems || loadingCampaign

  return (
    <>
      <Helmet>
        <title>{address || 'Campaign'} | Order Reconciliation</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button buttonStyle="primaryCreate" onClick={() => showAddAccountingItemModal({ campaign })} size="medium">
            Create Item
          </Button>
        )}
        activeTabBarItemKey="order-reconciliation"
        boxProps={{ height: [112, 105], justifyContent: 'flex-start' }}
        nestedNavigation
        tabBarItems={quoteAndFinanceTabBarItems(campaignId)}
        title="Accounting"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }}>
          <Columns.Main>
            <NotificationBannerLocation locationKey="agency.campaign.accounting.banner" />

            <LoadingModule loading={loading} times={3} />

            {!loadingCampaign && !loadingOrderReconciliationItems && (
              // @ts-expect-error TS2741
              <OrderReconciliationList
                campaign={campaign}
                orderReconciliationPayload={orderReconciliationPayload}
                title="Order Reconciliation"
              />
            )}
          </Columns.Main>

          <Columns.Sidebar>
            <NotificationModuleLocation locationKey="agency.campaign.accounting.sidebar" />

            <ReconciliationTotals campaign={campaign} />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}
export default PageContent
